import { render, staticRenderFns } from "./ProductPdfButtons.vue?vue&type=template&id=36310207&"
import script from "./ProductPdfButtons.vue?vue&type=script&lang=js&"
export * from "./ProductPdfButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports